<script>
	export default {
		props: {
			name: {
				type: String,
				required: true,
			},
			setActive: {
				type: [String, Boolean],
				default: undefined,
				required: false,
			},
		},
		computed: {
			active() {
				const overlays = this.$store.getters['skyOverlay/overlays'];
				if (this.name in overlays) {
					return overlays[this.name].active;
				}
				return false;
			},
		},
		methods: {
			toggleOverlay() {
				const payload = {
					name: this.name,
					active: undefined,
				};

				if (this.setActive !== undefined) {
					if (typeof this.setActive === 'boolean') {
						payload.active = this.setActive;
					} else {
						payload.active = (this.setActive === 'true');
					}
				}

				this.$store.dispatch('skyOverlay/toggle', payload);
			},
		},
	};
</script>

<template src="./sky-overlay-toggle.html"></template>



// WEBPACK FOOTER //
// sky-overlay-toggle.vue?208754ea